import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { appCfgApi } from '../services/api';

const LookupContext = createContext(null);

/**
 * LookupProvider - Caches all lookup values on app load.
 * Provides getValues(category) for dropdown options.
 */
export const LookupProvider = ({ children }) => {
  const [lookups, setLookups] = useState({});   // { category: [values] }
  const [loading, setLoading] = useState(true);

  // Fetch all lookups on mount
  useEffect(() => {
    const load = async () => {
      try {
        const res = await appCfgApi.getAllLookups();
        setLookups(res.data);
      } catch (err) {
        console.error('Failed to load lookups:', err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  // Get values for a category
  const getValues = useCallback((category) => {
    return lookups[category] || [];
  }, [lookups]);

  // Force refresh (after admin edits)
  const refresh = useCallback(async () => {
    try {
      const res = await appCfgApi.getAllLookups();
      setLookups(res.data);
    } catch (err) {
      console.error('Failed to refresh lookups:', err);
    }
  }, []);

  return (
    <LookupContext.Provider value={{ lookups, loading, getValues, refresh }}>
      {children}
    </LookupContext.Provider>
  );
};

export const useLookups = () => {
  const context = useContext(LookupContext);
  if (!context) {
    throw new Error('useLookups must be used within a LookupProvider');
  }
  return context;
};

export default LookupContext;
